var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4073 0.814986C5.6711 2.58337 3.8215 5.70495 3.8215 9.27246C3.8215 12.84 5.6711 15.9615 8.45316 17.7299C3.76036 17.7299 0 13.9471 0 9.27246C0 7.0294 0.885767 4.87822 2.46244 3.29214C4.03911 1.70605 6.17754 0.814986 8.4073 0.814986ZM26.0932 3.12157L28.2791 5.32052L4.4788 29.2629L2.2929 27.0639L26.0932 3.12157ZM16.6464 6.85824L14.3841 5.42816L12.1829 6.96588L12.825 4.35176L10.7002 2.72176L13.3752 2.53724L14.2618 0L15.286 2.50648L17.9305 2.55261L15.8669 4.29026L16.6464 6.85824ZM11.6021 12.4094L9.82889 11.2869L8.11686 12.4863L8.63659 10.4565L6.97041 9.18022L9.04931 9.04181L9.73718 7.05814L10.5168 9.01105L12.5957 9.0572L10.9906 10.395L11.6021 12.4094ZM25.9862 18.4988C25.9862 20.7419 25.1004 22.8931 23.5238 24.4791C21.947 26.0653 19.8087 26.9563 17.5789 26.9563C15.714 26.9563 13.9867 26.3412 12.5957 25.3109L24.3506 13.4858C25.3748 14.8851 25.9862 16.6228 25.9862 18.4988ZM19.2604 28.617L23.4946 26.8486L23.1277 32L19.2604 28.617ZM25.8792 24.4652L27.6371 20.2057L31 24.1115L25.8792 24.4652ZM27.6371 16.838L25.8945 12.5632L31 12.9322L27.6371 16.838ZM11.6632 26.8486L15.8974 28.617L12.0301 31.9846L11.6632 26.8486Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeLight);
export default __webpack_public_path__ + "static/media/theme-light.cbd00fd829dc4c30d1fee8217945eac1.svg";
export { ForwardRef as ReactComponent };